<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Your Collections</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-10 is-offset-1">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <div>
                  <b-field v-if="!newList" label="Select Collection">
                    <b-select
                      v-model="collection"
                      :expanded="true"
                      @input="
                        $router.push({
                          name: 'CartByList',
                          params: {
                            id: collection.id
                          }
                        })
                      "
                    >
                      <option
                        v-for="item in collections"
                        :key="item.id"
                        :value="item"
                        >{{ item.name }}</option
                      >
                    </b-select>
                  </b-field>
                  <b-field v-if="newList" label="New Collection Name">
                    <b-input v-model="collectionName" />
                  </b-field>
                  <a v-if="!newList" href="" @click.prevent="addNewList"
                    >Add New List</a
                  >
                  <a
                    v-if="!newList && collection"
                    href=""
                    class="has-margin-left-15"
                    @click.prevent="confirmCollectionRemove(collection)"
                    >Delete</a
                  >
                  <a v-if="newList" href="" @click.prevent="addCollection"
                    >Add</a
                  >
                  <a
                    v-if="newList"
                    href=""
                    class="has-margin-left-15"
                    @click.prevent="newList = false"
                    >Cancel</a
                  >
                </div>
                <ValidationObserver
                  v-if="collection"
                  ref="observer"
                  v-slot="{ passes }"
                >
                  <form
                    class="has-margin-top-15"
                    @submit.prevent="passes(submit)"
                  >
                    <div>
                      <div
                        v-if="cartItems.length === 0"
                        class="has-text-centered"
                      >
                        No items in your collection yet.
                      </div>
                      <div v-if="cartItems.length > 0">
                        <div
                          class="columns has-text-left has-text-weight-bold is-hidden-mobile"
                          style="border-bottom: 1px solid #eee;"
                        >
                          <div class="column is-2"></div>
                          <div class="column is-5">Title</div>
                          <div class="column is-2">Budget</div>
                          <div class="column is-1"></div>
                        </div>
                        <div
                          v-for="item in cartItems"
                          :key="item.id"
                          class="columns is-vcentered"
                        >
                          <div class="column is-2">
                            <router-link
                              v-if="item.media_id"
                              :to="{
                                name: 'MediaDetail',
                                params: { id: item.media_id }
                              }"
                            >
                              <figure v-if="getTitleImage(item)" class="image">
                                <img :src="getTitleImage(item)" />
                              </figure>
                            </router-link>
                            <router-link
                              v-else
                              :to="{
                                name: 'PackageDetail',
                                params: { id: item.package_id }
                              }"
                            >
                              <figure v-if="item.image" class="image">
                                <img :src="thumbnail(item.image)" />
                              </figure>
                            </router-link>
                          </div>
                          <div class="has-padding-left-15 column is-5">
                            <router-link
                              :to="{
                                name: 'MediaDetail',
                                params: { id: item.media_id }
                              }"
                            >
                              <h3 class="subtitle">{{ item.title }}</h3>
                            </router-link>
                          </div>
                          <div class="has-padding-left-15 column is-3">
                            <div class="columns">
                              <div class="column is-7">
                                <b-input
                                  v-model="item.budget"
                                  class="has-margin-right-5 has-margin-left-5"
                                  type="number"
                                  icon="currency-usd"
                                  @input="update(item)"
                                />
                              </div>
                              <div
                                class="column is-5"
                                style="padding-top: 18px;"
                              >
                                {{
                                  item.media_type === 'series' ||
                                  item.package_id
                                    ? 'per hour'
                                    : 'per title'
                                }}
                              </div>
                            </div>
                          </div>
                          <div
                            class="has-padding-left-15 column is-1 is-hidden-desktop is-hidden-tablet"
                          >
                            <b-button
                              icon-left="close"
                              @click="confirmRemove(item)"
                              >Remove</b-button
                            >
                          </div>
                          <div
                            class="has-padding-left-15 column is-1 has-text-centered is-hidden-mobile"
                          >
                            <a href="" @click.prevent="confirmRemove(item)"
                              ><b-icon icon="close"></b-icon
                            ></a>
                          </div>
                        </div>
                        <div class="has-text-centered has-margin-top-30">
                          <p v-if="collection.submitted" class="is-red">
                            You have already submitted your offer
                          </p>
                          <b-button
                            class="is-primary is-medium has-margin-top-15"
                            :loading="loading"
                            @click="submitOffer"
                            >{{
                              collection.submitted
                                ? 'Submit Updated Offer'
                                : 'Submit Offer'
                            }}</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
    <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to remove this title?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="remove()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
    <b-modal
      :active.sync="showConfirmCollectionModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmCollectionModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to remove this collection?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button
            class="button"
            type="button"
            @click="showConfirmCollectionModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="removeCollection()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import CartApi from '@/api/cart'
import CollectionApi from '@/api/collections'
import Utils from '@/mixins/utils'

export default {
  name: 'Cart',
  components: {
    CardComponent
  },
  mixins: [Utils],
  data() {
    return {
      initialized: false,
      loading: false,
      cartItems: [],
      showConfirmModal: false,
      showConfirmCollectionModal: false,
      item: {},
      collections: [],
      collection: null,
      collectionName: null,
      newList: false
    }
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.collection = this.collections.find(
          item => item.id.toString() === this.$route.params.id.toString()
        )
        this.fetchItems()
      }
    }
  },
  async created() {
    this.collections = await CollectionApi.getAll()
    if (this.$route.params.id) {
      this.collection = this.collections.find(
        item => item.id.toString() === this.$route.params.id
      )
      this.fetchItems()
    }
    this.initialized = true
  },
  methods: {
    async addCollection() {
      await CollectionApi.create({
        name: this.collectionName
      })
      this.collections = await CollectionApi.getAll()
      this.$buefy.toast.open({
        message: 'New collection created successfully!',
        position: 'is-top',
        type: 'is-success'
      })
      this.collectionName = ''
      this.newList = false
    },
    addNewList() {
      this.collectionName = ''
      this.collection = null
      this.newList = true
    },
    async fetchItems() {
      this.cartItems = []
      let items = await CartApi.getAll(this.collection.id)
      items.forEach(item => {
        if (item.mediadata) {
          item.mediadata = JSON.parse(item.mediadata)
        }
      })
      this.cartItems = items
    },
    getTitleImage(item) {
      return item.mediadata &&
        item.mediadata.titleImage &&
        item.mediadata.titleImage !== ''
        ? this.thumbnail(item.mediadata.titleImage)
        : null
    },
    async update(item) {
      await CartApi.update({
        cartItemId: item.id,
        mediaId: item.media_id,
        packageId: item.package_id,
        budget: item.budget
      })
    },
    confirmRemove(item) {
      this.showConfirmModal = true
      this.item = item
    },
    confirmCollectionRemove(item) {
      this.showConfirmCollectionModal = true
      this.item = item
    },
    remove() {
      CartApi.remove({
        cartItemId: this.item.id
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Title removed successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.cartItems = this.cartItems.filter(
            item => item.id !== this.item.id
          )
          this.showConfirmModal = false
          this.loading = false
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: 'Title removed deleting media',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    submitOffer() {
      this.loading = true
      CollectionApi.submitOffer(this.collection.id)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Your offer has been submitted',
            position: 'is-top',
            type: 'is-success'
          })
          this.collection.submitted = true
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error submitting your offer',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    removeCollection() {
      this.loading = true
      CollectionApi.remove(this.item.id)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Collection removed successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.collections = this.collections.filter(
            item => item.id !== this.item.id
          )
          this.showConfirmCollectionModal = false
          this.collection = null
          this.cartItems = []
          CollectionApi.getAll().then(response => {
            this.collections = response
          })
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error deleting collection',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
